import Api from '@/services/Api'

// Slanje platnih lista zaposlenicima e-mailom i evidencija slanja.
//
// PDF se slaze na ekranu (ista petlja koja crta "Print SVI") i salje gotov,
// po zaposleniku, kodiran u base64.
export default {
  // {CompanyId, databaseDocID, Month, Year, predmet, tekst, stavke:[{empID, ime, eemail, pdf}],
  //  probnaAdresa?, dopustiZajednicku?}
  posalji (podaci) {
    return Api().post('platneliste/mail', podaci)
  },
  // {CompanyId, databaseDocID?, Year?, Month?}
  evidencija (query) {
    return Api().get('platneliste/mail', {params: query})
  }
}
